var _path, _path2, _path3, _path4, _g, _use, _g2, _use2, _path5, _path6, _path7, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path8, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _path9, _path10, _path11, _path12, _path13, _path14, _ellipse13, _path15, _path16, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path17, _circle7, _rect, _path18, _path19, _path20, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007E3C",
    d: "M0 0h1200v600H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DF1A23",
    d: "M0 0h1200v400H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h1200v200H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#DF1A23",
    d: "M0 0h400v600H0z"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    x: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: 0.352
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.854,
    y: 102.64,
    width: 38.669,
    height: 21.217,
    ry: 3.015,
    rx: 3.215,
    strokeWidth: 0.378
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.846,
    y: 103.52,
    width: 36.686,
    height: 19.449,
    ry: 2.764,
    rx: 3.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.904 108.83 1.853.06.084.84 1.516.77 1.18-.96 1.431.77-1.347.84.337 1.16 1.684-.06v1.55l-1.347-.07-.674.97 1.516 1.1-1.179.9-1.264-.97-1.853.39.084 1.42-2.021.13-.253-1.36-1.684-.71-.927.97-1.432-.71.843-1.1-1.011-.71h-1.432l-.084-2 1.432.13 1.01-1.16-1.179-.9 1.516-1.04 1.095.84 1.853-.25z",
    strokeWidth: 0.222
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.18418 0 0 .1752 71.766 38.246)",
    ry: 9.944,
    rx: 11.049,
    cy: 426.78,
    cx: 68.944,
    strokeWidth: 1.333
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.803 104.41-2.974 2.65m4.957-2.65-2.974 2.65m4.957-2.65-2.974 2.65m4.957-2.65-2.974 2.65m4.957-2.65-2.974 2.65m4.957-2.65-2.974 2.65m4.958-2.65-2.975 2.65m4.958-2.65-2.975 2.65m4.958-2.65-2.975 2.65m4.958-2.65-2.975 2.65m4.958-2.65-2.975 2.65m4.958-2.65-2.975 2.65m-4.957-2.65-2.975 2.65m12.89-2.65-2.975 2.65m4.958-2.65-2.975 2.65m4.958-2.65-2.975 2.65m4.959-2.65-2.976 2.65m0-2.65 2.976 2.65m-4.959-2.65 2.975 2.65m-4.958-2.65 2.975 2.65m-4.958-2.65 2.975 2.65m-4.958-2.65 2.975 2.65m-4.958-2.65 2.975 2.65m-4.958-2.65 2.975 2.65m-4.958-2.65 2.975 2.65m-4.958-2.65 2.975 2.65m-4.958-2.65 2.975 2.65m-4.958-2.65 2.975 2.65m-4.958-2.65 2.974 2.65m4.958-2.65 2.975 2.65m-12.89-2.65 2.974 2.65m-4.957-2.65 2.974 2.65m-4.957-2.65 2.974 2.65m-4.957-2.65 2.974 2.65m0 12.37-2.974 2.66m4.957-2.66-2.974 2.66m4.957-2.66-2.974 2.66m4.957-2.66-2.974 2.66m4.957-2.66-2.974 2.66m4.957-2.66-2.974 2.66m4.958-2.66-2.975 2.66m4.958-2.66-2.975 2.66m4.958-2.66-2.975 2.66m4.958-2.66-2.975 2.66m4.958-2.66-2.975 2.66m4.958-2.66-2.975 2.66m-4.957-2.66-2.975 2.66m12.89-2.66-2.975 2.66m4.958-2.66-2.975 2.66m4.958-2.66-2.975 2.66m4.959-2.66-2.976 2.66m0-2.66 2.976 2.66m-4.959-2.66 2.975 2.66m-4.958-2.66 2.975 2.66m-4.958-2.66 2.975 2.66m-4.958-2.66 2.975 2.66m-4.958-2.66 2.975 2.66m-4.958-2.66 2.975 2.66m-4.958-2.66 2.975 2.66m-4.958-2.66 2.975 2.66m-4.958-2.66 2.975 2.66m-4.958-2.66 2.975 2.66m-4.958-2.66 2.974 2.66m4.958-2.66 2.975 2.66m-12.89-2.66 2.974 2.66m-4.957-2.66 2.974 2.66m-4.957-2.66 2.974 2.66m-4.957-2.66 2.974 2.66"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    transform: "scale(-1 1)",
    x: -300,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#a",
    width: "100%",
    height: "100%"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b",
    stroke: "#db161b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.51 147.12c-48.114 47.05-68.638 53-59.006 56.79 9.632 3.79 40.616-20.49 72.856-52.75 32.24-32.25 51.98-60.956 42.35-64.747-9.63-3.792-5.03 10.662-56.2 60.707z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0.565
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.008 181.31 16.852 4.42c-15.861 15.03-33.708 21.22-38.665 18.57-4.958-2.65 8.923-8.84 21.813-22.99z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.008 183.08 13.881 3.54c-15.453 14.45-30.737 18.56-34.692 16.8-3.977-1.77 8.255-6.74 20.811-20.34z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.79 145.06c-.04.23-.15 1.24-.25 1.64 0 .56-.06.98-.12 1.42-.16.38-.13.73-.62.87-.33.46-.54.58-.98.77-.3.23-.76.46-1.24.65-.49.19-.94.21-1.47.11-.44-.27-.75-.54-1.11-.76-.09-.35-.16-.86-.25-1.2.13.35.23.91.25 1.41-.05.55-.25.79-.49 1.2m1.72 1.2c-.04-.03-.08-.07-.12-.11.29.26.17.14-.5-.21-.47-.22-.98-.34-1.6-.44h-1.72c-.67 0-1.12.09-1.6.22-.35.31-.87.48-1.23.76-.38.23-.54.5-.74.87-.34.3-.56.76-.87.99-.13.5-.42.48-.61.87.58.04 1.05.11 1.35.43.52.24-.43-.23-.61-.43-.41-.11-.51-.22-1.11-.22-.56-.16-.9.13-1.48.22-.33.17-.43.22-.86.22m5.05 2.29c-.25.01-1.4.2-1.85 0-.5-.12-.8-.36-1.11-.77-.15-.29 0 .53 0 .88-.05.64-.27.65-.61 1.09-.36.2-.74.49-1.11.65-.31.24-.69.4-1.11.55-.37.15-.81.31-1.11.54-.41.26-.37.58-.61.98.04.54.14.84.49 1.1.14.36.47.73.74.98.3.5.64.73-.13.87-.42.16-.65.03-1.1 0m-.25.76c-.3-.06-1.38-.38-1.85-.54h-1.72c-.67.04-.8.22-1.36.43-.36.33-.61.56-1.11.77-.26.3-.78.81-.98 1.2-.15.37-.25.87-.25 1.42.01.63.2.74.25 1.31.14.46.36.89.74 1.3.05.14.09.18.24.22m.17 1.43c-.05 0-.17.28-.35.52-.39.4-.44.43-1.05.43-.54-.02-.49-.21-.87-.35-.18-.27-.41-.49-.61-.86-.14-.22-.27-.57-.44-.77-.16-.26-.36-.45-.53-.69-.16-.07-.22-.14-.43-.17.5.08.54.25.87.51.15.25.31.5.44.78.05.37.17.66.17 1.12 0 .47 0 .81-.17 1.2-.21.22-.36.44-.61.61-.21.19-.46.45-.62.68-.27.17-.47.31-.78.52-.27.15-.55.31-.96.35-.52-.04-.67-.18-1.05-.35-.33-.24-.59-.39-.88-.6-.23-.16-.46-.47-.61-.69-.47-.12-.77-.07-1.05.17-.24.16-.45.37-.61.6-.15.07-.38.28-.53.35m1.04.2c.14.06.64.41.87.54.14.45.36.7.43 1.18.12.47.11.98.11 1.51-.12.55-.35.95-.54 1.39-.35.24-.52.4-.98.65-.43.06-.86.11-1.41.11-.34.11-.98.16-1.31 0-.48-.07-.843-.26-1.194-.43-.402-.23-.649-.44-1.088-.65-.213-.31-.544-.59-.869-.97-.271-.36-.47-.56-.653-.96.161.46.405.86.544 1.29.247.45.391.62.435 1.18.151.45.109.99.109 1.5-.048.35-.073 1.01-.218 1.29v.33m-10.314 1.71v.16c0-.42-.011-.21.175.62.33.37 1.104.47 1.749.31.566-.41.548-.73 1.574-.93.991.06 1.369.32 1.924.62.658.29.962.44 1.399 1.09.217.53.338.89-.35 1.09-.547.35-1.197.54-1.924.63-.808 0-1.39-.09-1.749.31-.555.51-.524.82-.524 1.71-.187.28-.224 1.1-.35 1.41-.486.2-.771.31-1.574.31-.189-.48-.398-1.35-.525-1.87-.137-.56-.179-1.34-.525-1.72a4.51 4.51 0 0 0-1.224-1.09c-.214-.27-.622-.49-1.049-.62.686.31.784.65.874 1.4-.603.27-.764.46-1.749.47-.968-.07-1.202-.29-1.574-.78-.067.78-.348 1.04-.524 1.72-.36.47-.513.95-.875 1.55.154.76.486.79.525 1.72.227.61.202 1.19.699 1.56.222.24.388.29.875.31-1.013 0-1.603-.1-2.274-.47-.519-.28-.911-.64-1.399-.93-.619-.4-1.384-.77-2.099-.94-.808 0-1.39-.08-1.749.31-.495.32-.828.86-1.049 1.56-.162.81-.224 1.35.175 1.87.296.61.363.84 0 1.56-.407.51-1.012.57-1.924.78a6.678 6.678 0 0 1-1.749-.31",
    fill: "none",
    strokeWidth: 0.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.41 104.66c21.35-36.858 35.52-68.222 31.62-70.014-3.89-1.791-24.37 26.665-45.72 63.518z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0.447
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 104.01c20.59-35.557 34.78-65.574 31.67-67.007-3.11-1.433-22.35 26.258-42.95 61.81",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0.393
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.46 85.461c-2.51 4.157-5.16 8.908-7.74 13.352L180 104.01c2.57-4.448 5.38-9.13 7.73-13.356z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0.446
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.41 86.895c-2.5 4.157-4.25 7.338-6.82 11.782l8.45 3.893c2.58-4.442 4.48-7.554 6.83-11.78z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0.446
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-.90832 -.41827 -.50125 .8653 0 0)",
    fill: "#fff",
    strokeWidth: 0.447,
    d: "M-205.69 6.558h6.207v9.985h-6.207z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.55 91.712-10.64 6.043m5.63 2.595-.63-11.235m31.12-41.388-5.64-2.597",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0.446
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 545.67,
    cy: 92.126,
    transform: "matrix(-.449 .1132 .10134 .39387 444.347 -55.798)",
    r: 3.543,
    fill: "#db161b",
    strokeWidth: 1.333
  }))), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    transform: "scale(-1 1)",
    x: -300,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#b",
    width: "100%",
    height: "100%"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M135.26 84.958c0 30.942.18 42.602-2.1 44.202-2.16 1.71-62.348 0-62.348 8.84s49.578 17.68 64.448 17.68c19.83 0 29.75-8.84 29.75-26.52V84.958z",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: 0.407
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M135.26 93.798v4.42a100.628 100.628 0 0 0 29.75 0v-4.42a100.628 100.628 0 0 1-29.75 0zm0-8.84v4.42a100.695 100.695 0 0 0 29.75 0v-4.42a100.695 100.695 0 0 1-29.75 0z",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: 0.352
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M135.26 89.378v4.42a100.628 100.628 0 0 0 29.75 0v-4.42a100.695 100.695 0 0 1-29.75 0zm0 8.84v4.422c9.92 1.47 19.83 1.47 29.75 0v-4.422a100.628 100.628 0 0 1-29.75 0z",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: 0.352
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 256.89,
    cy: 210.83,
    transform: "matrix(.15263 0 0 .03588 97.403 84.326)",
    ry: 26.575,
    rx: 8.858,
    fill: "#fff",
    stroke: "#db161b",
    strokeWidth: 4.463
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 292.32,
    cy: 246.26,
    transform: "matrix(.15263 0 0 .03588 97.403 83.53)",
    ry: 26.575,
    rx: 8.858,
    fill: "#fff",
    stroke: "#db161b",
    strokeWidth: 4.463
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 327.76,
    cy: 263.98,
    transform: "matrix(.15263 0 0 .03588 97.403 83.372)",
    ry: 26.575,
    rx: 8.858,
    fill: "#fff",
    stroke: "#db161b",
    strokeWidth: 4.463
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 363.19,
    cy: 263.98,
    transform: "matrix(.15263 0 0 .03588 97.403 83.372)",
    ry: 26.575,
    rx: 8.858,
    fill: "#fff",
    stroke: "#db161b",
    strokeWidth: 4.463
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 398.62,
    cy: 246.26,
    transform: "matrix(.15263 0 0 .03588 97.403 83.53)",
    ry: 26.575,
    rx: 8.858,
    fill: "#fff",
    stroke: "#db161b",
    strokeWidth: 4.463
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 434.06,
    cy: 210.83,
    transform: "matrix(.15263 0 0 .03588 97.403 84.326)",
    ry: 26.575,
    rx: 8.858,
    fill: "#fff",
    stroke: "#db161b",
    strokeWidth: 4.463
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m135.26 107.06 29.75 23.87m-26.78-23.87 26.78 21.21m-22.81-20.33 22.81 17.68m-19.83-17.68 19.83 15.03m-16.86-15.03 16.86 12.38m-13.89-12.38 13.89 9.73m-10.91-9.73 10.91 7.07m-7.94-7.07 7.94 5.31m-4.96-5.31 4.96 3.54m-1.99-3.54 1.99 1.77m-29.75 0 29.75 23.87m0-26.52-32.72 26.52m29.74-26.52-28.75 22.98m24.79-22.1-22.81 17.68m19.83-17.68-19.83 15.03m16.86-15.03-16.86 12.38m13.88-12.38-13.88 9.73m10.91-9.73-10.91 7.07m7.93-7.07-7.93 5.31m4.96-5.31-4.96 3.54m1.98-3.54-1.98 1.77m29.75 0-32.72 26.52m32.72-23.87-32.72 26.52m32.72-23.87-32.72 26.53m32.72-23.87-32.72 26.52m32.72-23.87-32.72 26.52m32.72-23.87-32.72 26.52m32.72-23.87-32.72 26.52m32.72-23.86-32.72 26.52m32.72-23.87-30.74 24.75m30.74-22.1-27.77 22.1m26.77-18.56L142.2 154.8m20.82-14.15-17.84 14.15m15.86-9.73-8.92 7.07m-16.86-39.78 28.75 22.99m-28.75-20.34L164.01 138m-28.75-20.33 27.76 22.1m-27.76-19.45 27.76 22.1m-27.76-19.45 26.77 21.22m-27.76-19.45 26.77 21.22m-26.77-18.57 24.79 19.45m-25.78-17.68 24.79 19.45m-25.78-17.68 23.79 18.56m-23.79-15.91 22.8 17.68m-22.8-15.03 19.83 15.91M135.26 102.64v4.42c9.92 1.47 19.83 1.47 29.75 0v-4.42c-9.92 1.47-19.83 1.47-29.75 0zm-2.97 36.24 17.84 14.15m-17.84-11.49 15.86 12.37m-15.86-9.72 13.88 10.61m-13.88-7.96 9.91 7.96m-9.91-5.31 7.93 6.19m-7.93-3.54 4.95 3.54",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: 0.352
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 256.89,
    cy: 210.83,
    transform: "matrix(.15263 0 0 .03588 97.403 97.586)",
    ry: 26.575,
    rx: 8.858,
    fill: "#fff",
    stroke: "#db161b",
    strokeWidth: 4.463
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 292.32,
    cy: 246.26,
    transform: "matrix(.15263 0 0 .03588 97.403 96.791)",
    ry: 26.575,
    rx: 8.858,
    fill: "#fff",
    stroke: "#db161b",
    strokeWidth: 4.463
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 327.76,
    cy: 263.98,
    transform: "matrix(.15263 0 0 .03588 97.403 96.632)",
    ry: 26.575,
    rx: 8.858,
    fill: "#fff",
    stroke: "#db161b",
    strokeWidth: 4.463
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 363.19,
    cy: 263.98,
    transform: "matrix(.15263 0 0 .03588 97.403 96.632)",
    ry: 26.575,
    rx: 8.858,
    fill: "#fff",
    stroke: "#db161b",
    strokeWidth: 4.463
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 398.62,
    cy: 246.26,
    transform: "matrix(.15263 0 0 .03588 97.403 96.791)",
    ry: 26.575,
    rx: 8.858,
    fill: "#fff",
    stroke: "#db161b",
    strokeWidth: 4.463
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 434.06,
    cy: 210.83,
    transform: "matrix(.15263 0 0 .03588 97.403 97.586)",
    ry: 26.575,
    rx: 8.858,
    fill: "#fff",
    stroke: "#db161b",
    strokeWidth: 4.463
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m92.625 148.61 35.695-18.57m-37.678 17.68 33.708-17.68m-34.699 15.92 30.739-15.92m-31.731 14.15 26.771-14.15m-28.754 12.38 24.784-12.38m-23.792 9.73 16.852-8.84M86.676 138l12.89-7.07m-12.89 4.42 8.924-4.42m0 18.56 33.71-17.68m-30.736 18.57 31.726-16.8m-28.75 17.68 29.74-15.91m-26.77 16.79 24.79-13.26m-20.82 13.26 21.81-11.49m-18.84 12.38 18.84-9.73m-15.86 10.61 14.87-7.95m-10.91 7.95 11.9-6.19m-7.93 7.08 7.93-4.42m-3.96 4.42 4.95-2.66M133.28 129.16h-4.96a71.66 71.66 0 0 0 0 26.52h4.96a71.236 71.236 0 0 1 0-26.52zm-58.502 12.38 11.898-8.84m-11.898 2.65 11.898 10.61",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: 0.352
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m92.625 130.93-5.949.88c-1.322 5.6-1.322 10.31 0 15.91l5.949 1.77c-1.322-5.6-1.322-12.96 0-18.56z",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: 0.251
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M164.97 86.726v-4.457c-4.45.037-7.43-2.615-7.43-5.305l-14.85.037c0 2.653-2.97 5.305-7.43 5.305v4.42z",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: 0.431
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#db161b",
    strokeWidth: 0.364,
    d: "M143.75 71.697h12.734v5.304H143.75zm1.06-5.304h10.612v5.304H144.81zm0-5.304h10.612v5.304H144.81z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#db161b",
    strokeWidth: 0.364,
    d: "M145.87 54.017h8.489v7.072h-8.489z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#db161b",
    strokeWidth: 0.38,
    d: "M145.51 47.829h9.221v6.188h-9.221z"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 237.4,
    cy: 161.22,
    transform: "matrix(.28916 0 0 .2495 81.983 1.86)",
    ry: 33.661,
    rx: 42.52,
    fill: "#fff",
    stroke: "#db161b",
    strokeWidth: 1.333
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M156.78 41.64c0 2.319 3.07 6.189 3.07 6.189-2.23 1.52-5.83 2.652-9.22 2.652-3.39 0-7.62-.631-9.22-2.652 0 0 3.07-3.87 3.07-6.189 0-2.318-3.07-5.304-3.07-5.304 2.22-1.52 5.83-2.652 9.22-2.652 3.39 0 6.99 1.132 9.22 2.652 0 0-3.07 2.986-3.07 5.304z",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: 0.358
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M154.73 41.64c0 2.319 3.07 7.073 3.07 7.073-2.22 1.52-3.78 1.768-7.17 1.768s-5.57.253-7.17-1.768c0 0 3.07-4.754 3.07-7.073 0-2.318-3.07-6.188-3.07-6.188 2.22-1.52 3.78-1.768 7.17-1.768s4.95.248 7.17 1.768c0 0-3.07 3.87-3.07 6.188z",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: 0.358
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 194.88,
    cy: 166.54,
    transform: "matrix(.28916 0 0 .2495 81.983 .975)",
    r: 10.63,
    fill: "#fff",
    stroke: "#db161b",
    strokeWidth: 1.333
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.88,
    cy: 166.54,
    transform: "matrix(.28916 0 0 .2495 106.572 .975)",
    r: 10.63,
    fill: "#fff",
    stroke: "#db161b",
    strokeWidth: 1.333
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.88,
    cy: 166.54,
    transform: "matrix(.28916 0 0 .2495 94.278 .975)",
    r: 10.63,
    fill: "#fff",
    stroke: "#db161b",
    strokeWidth: 1.333
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.88,
    cy: 166.54,
    transform: "matrix(.28916 0 0 .2495 94.278 -7.865)",
    r: 10.63,
    fill: "#fff",
    stroke: "#db161b",
    strokeWidth: 1.333
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.88,
    cy: 166.54,
    transform: "matrix(.29948 0 0 .2495 83.264 42.524)",
    r: 10.63,
    fill: "#fff",
    stroke: "#db161b",
    strokeWidth: 1.333
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.88,
    cy: 166.54,
    transform: "matrix(.29948 0 0 .2495 100.242 42.524)",
    r: 10.63,
    fill: "#fff",
    stroke: "#db161b",
    strokeWidth: 1.333
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M142.69 77.001h14.85l-7.42 7.957z",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: 0.364
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.88,
    cy: 166.54,
    transform: "matrix(.39931 0 0 .33266 72.298 27.79)",
    r: 10.63,
    fill: "#fff",
    stroke: "#db161b",
    strokeWidth: 1.333
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 133.77,
    y: 109.72,
    width: 22.805,
    height: 5.304,
    ry: 0.938,
    rx: 1.238,
    fill: "#fff",
    stroke: "#db161b",
    strokeWidth: 0.33
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M163.52 105.3c-2.75 0-4.96 2.06-4.96 4.62v4.02c0 2.56 2.21 4.62 4.96 4.62s4.96-2.06 4.96-4.62v-4.02c0-2.56-2.21-4.62-4.96-4.62zm0 1.77c-1.65 0-2.98 1.65-2.98 3.7v2.33c0 2.05 1.33 3.69 2.98 3.69s2.97-1.64 2.97-3.69v-2.33c0-2.05-1.32-3.7-2.97-3.7zm-25.78-.88c-1.65 0-2.97 1.64-2.97 3.69v4.1c0 2.05 1.32 3.7 2.97 3.7 1.65 0 2.97-1.65 2.97-3.7v-4.1c0-2.05-1.32-3.69-2.97-3.69zm0-1.77c-2.75 0-4.96 2.06-4.96 4.62v5.79c0 2.56 2.21 4.62 4.96 4.62s4.96-2.06 4.96-4.62v-5.79c0-2.56-2.21-4.62-4.96-4.62z",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: 0.33
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M129.81 107.95c-1.65 0-2.98 1.65-2.98 3.7v.96c0 2.05 1.33 3.7 2.98 3.7s2.97-1.65 2.97-3.7v-.96c0-2.05-1.32-3.7-2.97-3.7zm0-1.76c-2.75 0-4.96 2.06-4.96 4.62v2.65c0 2.56 2.21 4.62 4.96 4.62 2.74 0 4.96-2.06 4.96-4.62v-2.65c0-2.56-2.22-4.62-4.96-4.62z",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: 0.33
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M117.91 105.51c-2.97 0-5.35 1.84-5.35 4.13v4.58c0 2.29 2.38 4.13 5.35 4.13 2.97 0 5.35-1.84 5.35-4.13v-4.58c0-2.29-2.38-4.13-5.35-4.13zm0-1.98c-4.94 0-8.92 2.31-8.92 5.17v6.47c0 2.86 3.98 5.16 8.92 5.16 4.94 0 8.92-2.3 8.92-5.16v-6.47c0-2.86-3.98-5.17-8.92-5.17zm64.45 2.86c-2.97 0-5.36 1.85-5.36 4.14v4.58c0 2.29 2.39 4.13 5.36 4.13 2.96 0 5.35-1.84 5.35-4.13v-4.58c0-2.29-2.39-4.14-5.35-4.14zm0-1.97c-4.95 0-8.93 2.3-8.93 5.16v6.47c0 2.86 3.98 5.16 8.93 5.16 4.94 0 8.92-2.3 8.92-5.16v-6.47c0-2.86-3.98-5.16-8.92-5.16z",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: 0.33
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 165.5,
    y: 109.72,
    width: 11.898,
    height: 5.304,
    ry: 0.938,
    rx: 0.646,
    fill: "#fff",
    stroke: "#db161b",
    strokeWidth: 0.33
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 154.6,
    y: 108.84,
    width: 6.941,
    height: 7.072,
    ry: 1.251,
    rx: 0.377,
    fill: "#fff",
    stroke: "#db161b",
    strokeWidth: 0.33
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 121.88,
    y: 108.84,
    width: 6.941,
    height: 7.072,
    ry: 1.251,
    rx: 0.377,
    fill: "#fff",
    stroke: "#db161b",
    strokeWidth: 0.33
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 100.06,
    y: 107.95,
    width: 13.881,
    height: 8.84,
    ry: 1.563,
    rx: 0.753,
    fill: "#fff",
    stroke: "#db161b",
    strokeWidth: 0.33
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 186.32,
    y: 108.84,
    width: 12.89,
    height: 8.84,
    ry: 1.563,
    rx: 0.7,
    fill: "#fff",
    stroke: "#db161b",
    strokeWidth: 0.33
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOm);
export default __webpack_public_path__ + "static/media/om.5f106a92795275275fe4b003ec485ff6.svg";
export { ForwardRef as ReactComponent };